export type OSInfo = "windows" | "mac-intel" | "mac-m2" | null;

type NavigatorUAData = {
  readonly brands: Array<{ brand: string; version: string }>;
  readonly mobile: boolean;
  readonly platform: string;
  getHighEntropyValues?(hints: string[]): Promise<{ architecture: string }>;
}

function detectOSFromUserAgent(ua: string): OSInfo {
  if (ua.includes("Windows")) return "windows";
  if (ua.includes("Mac OS") || ua.includes("Macintosh")) {
    return ua.toLowerCase().includes("arm") ? "mac-m2" : "mac-intel";
  }
  return null;
}

async function detectMacArchitecture(uaData: NavigatorUAData): Promise<OSInfo> {
  if (uaData.getHighEntropyValues) {
    try {
      const { architecture } = await uaData.getHighEntropyValues(["architecture"]);
      return architecture === "arm64" ? "mac-m2" : "mac-intel";
    } catch (e) {
      console.error("Error while fetching architecture from UA Client Hints", e);
    }
  }
  return navigator.userAgent.toLowerCase().includes("arm") ? "mac-m2" : "mac-intel";
}

export async function getOSInfo(): Promise<OSInfo> {
  const ua = navigator.userAgent;
  if ("userAgentData" in navigator && navigator.userAgentData) {
    const uaData = navigator.userAgentData as NavigatorUAData;
    if (uaData.platform === "Windows") return "windows";
    if (uaData.platform === "macOS") return await detectMacArchitecture(uaData);
  }
  return detectOSFromUserAgent(ua);
}
